// src/data/categories.ts
import { Category } from '../types';

export const categories: Category[] = [
    {
        id: 'all',
        name: '전체 지원금',
        shortName: '전체',
        icon: 'grid',
        path: '/',
        accent: '#2563EB',
        tagline: '2026년 정부지원금을 한 곳에서',
        description:
            '근로·주거·출산육아·교육·창업·복지까지, 2026년 현재 신청할 수 있는 대한민국 정부지원금을 분야별로 정리했습니다.',
        keywords: '정부지원금, 2026 정부지원금, 정부보조금, 지원금 신청, 복지 혜택'
    },
    {
        id: 'worker',
        name: '근로자·일자리 지원금',
        shortName: '근로·일자리',
        icon: 'briefcase',
        path: '/worker',
        accent: '#2563EB',
        tagline: '일하는 사람을 위한 현금·훈련 지원',
        description:
            '근로장려금, 실업급여, 국민내일배움카드, 청년일자리도약장려금 등 근로자와 사업주가 함께 받을 수 있는 2026년 고용 지원 제도를 정리했습니다.',
        keywords:
            '근로장려금, 실업급여, 국민내일배움카드, 청년일자리도약장려금, 고용장려금, 근로자 지원금'
    },
    {
        id: 'housing',
        name: '주거 지원금',
        shortName: '주거',
        icon: 'home',
        path: '/housing',
        accent: '#0EA5E9',
        tagline: '전세·월세·공공임대 주거비 부담 줄이기',
        description:
            '주거급여, 청년월세지원, 버팀목 전세자금대출, 공공임대주택 등 2026년 주거비 부담을 줄여주는 정부 지원 제도를 모았습니다.',
        keywords:
            '주거급여, 청년월세지원, 버팀목전세자금대출, 공공임대주택, 행복주택, 전세대출, 주거 지원금'
    },
    {
        id: 'parenting',
        name: '출산·육아 지원금',
        shortName: '출산·육아',
        icon: 'baby',
        path: '/parenting',
        accent: '#EC4899',
        tagline: '임신부터 초등까지 이어지는 육아 혜택',
        description:
            '첫만남이용권, 부모급여, 아동수당, 육아휴직급여, 육아기 근로시간 단축급여 등 2026년 출산·양육 지원금을 한눈에 확인하세요.',
        keywords:
            '첫만남이용권, 부모급여, 아동수당, 육아휴직급여, 육아기 근로시간 단축급여, 출산지원금, 임신바우처'
    },
    {
        id: 'education',
        name: '교육·자기계발 지원',
        shortName: '교육',
        icon: 'book',
        path: '/education',
        accent: '#8B5CF6',
        tagline: '등록금·훈련비·평생학습 지원',
        description:
            '국가장학금, 교육급여, 평생교육바우처, 청년도전지원사업 등 학비와 자기계발 비용을 덜어주는 2026년 교육 지원 제도입니다.',
        keywords:
            '국가장학금, 교육급여, 평생교육바우처, 학자금대출, 청년도전지원사업, 교육 지원금'
    },
    {
        id: 'business',
        name: '창업·소상공인 지원',
        shortName: '창업·사업',
        icon: 'rocket',
        path: '/business',
        accent: '#F59E0B',
        tagline: '창업 자금과 소상공인 경영 지원',
        description:
            '예비창업패키지, 초기창업패키지, 소상공인 정책자금, 노란우산공제 등 창업자와 소상공인을 위한 2026년 지원 사업을 정리했습니다.',
        keywords:
            '예비창업패키지, 초기창업패키지, 창업지원금, 소상공인 정책자금, 노란우산공제, 청년창업'
    },
    {
        id: 'welfare',
        name: '복지·취약계층 지원',
        shortName: '복지',
        icon: 'heart',
        path: '/welfare',
        accent: '#10B981',
        tagline: '기초생활보장과 생활비 경감 제도',
        description:
            '기초생활보장 생계·의료급여, 기초연금, 긴급복지지원, 에너지바우처, 통신비 감면 등 2026년 복지 지원 제도를 안내합니다.',
        keywords:
            '기초생활수급, 생계급여, 의료급여, 기초연금, 긴급복지지원, 에너지바우처, 차상위계층, 통신비 감면'
    }
];

export const getCategory = (id: string): Category =>
    categories.find(c => c.id === id) ?? categories[0];

export const navCategories = categories;
